import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Panel, Icon, Form, Col, Button, Message, Checkbox } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import TextareaRadioForm from '../../components/forms/textareaRadioForm/TextareaRadioForm'
import { startLoading, doneLoading } from '../../utils/loading'
import { saveApproveProject } from '../../redux/actions/approveProject'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { Link } from 'react-router-dom'
import CoiApproveProjectWidget from '../coi/CoiApproveProjectWidget'
import COIValidateWidget from '../coi/COIValidateWidget'

export default function OfferingApproveProposal({
  schema,
  projectVersionId,
  onComplete,
  approverComment,
}) {
  const history = useHistory()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)
  const [isShowConfimModalOffering, setIsShowConfimModalOffering] = useState(false)
  const [isShowConfimModalEdit, setIsShowConfimModalEdit] = useState(false)
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors, watch } =
    useForm()

  const [formSchema, setFormSchema] = useState(schema)
  const [isCheckCOI, setIsCheckCOI] = useState(false)
  const [isCOIPass, setIsCOIPass] = useState(false)
  const [checkCOI, setCheckCOI] = useState(false)
  const [checkInterest, setCheckInterest] = useState(false)
  const [showCOIDetail, setShowCOIDetail] = useState(false)

  const handleSaveOfferingApproveProject = async (request) => {
    startLoading()
    setIsLoading(true)
    setErrorMessage(null)
    try {
      const _schema = await saveApproveProject(request, projectVersionId || projectId)
      doneLoading()
      if (typeof onComplete === 'function') {
        onComplete()
      } else {
        const _projectVersionId =
          _schema.projectVersionId ||
          _schema.model?.projectVersionId ||
          projectVersionId ||
          projectId

        setIsShowConfimModalOffering(false)
        setIsLoading(false)
        doneLoading()
        sessionStorage.setItem('projectId', _projectVersionId)
        sessionStorage.setItem('param', '')
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      }
    } catch (e) {
      if (e?.response?.data?.errorMessage) {
        setErrorMessage(e?.response?.data?.errorMessage)
      } else {
        setErrorMessage('เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    setIsShowConfimModalOffering(false)
    setIsLoading(false)
    doneLoading()
  }

  const onSubmitOfferingApproveProposal = () => {
    setIsShowConfimModalOffering(true)
  }

  const handleOnConfirmModalOffering = (data) => {
    const requestData = {
      value: data.remark,
      selected: '1',
      isCOI: checkInterest,
    }
    handleSaveOfferingApproveProject(requestData)
  }

  const handleSendToEdit = async (request) => {
    startLoading()
    setIsLoading(true)
    setErrorMessage(null)
    try {
      const _schema = await saveApproveProject(request, projectVersionId || projectId)
      doneLoading()
      if (typeof onComplete === 'function') {
        onComplete()
      } else {
        const _projectVersionId =
          _schema.projectVersionId ||
          _schema.model?.projectVersionId ||
          projectVersionId ||
          projectId

        setIsShowConfimModalEdit(false)
        setIsLoading(false)
        doneLoading()
        sessionStorage.setItem('projectId', _projectVersionId)
        sessionStorage.setItem('param', '')
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      }
    } catch (e) {
      if (e.response && e.response.data && e.response.data.status == 401) {
        setErrorMessage(e.response.data.errorMessage)
      } else {
        setErrorMessage('เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    setIsShowConfimModalEdit(false)
    setIsLoading(false)
    doneLoading()
  }

  const onSubmitSendToEdit = () => {
    setIsShowConfimModalEdit(true)
  }

  const handleOnConfirmModalEdit = (data) => {
    const requestData = {
      value: data.remark,
      selected: '2',
    }
    handleSendToEdit(requestData)
  }

  return (
    <>
      <Form fluid>
        <Panel
          shaded
          header={formSchema.headerApproveProposal}
          bordered
          collapsible
          defaultExpanded
        >
          {approverComment?.length > 0 &&
            approverComment.map((item, index) => {
              return (
                item.label != 'ความเห็นของนักวิชาการผู้เสนออนุมัติ' && (
                  <Message
                    key={index}
                    type={'info'}
                    description={`${item.label} : ${item.value}`}
                  />
                )
              )
            })}

          <>
            {formSchema.alert && (
              <>
                <Message showIcon type="warning" description={formSchema.alert} />
                <br />
              </>
            )}
            <TextareaRadioForm
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />

            {/*check coi ยืนยันไม่มีส่วนได้เสีย*/}
            {/* <CoiApproveProjectWidget
              check={checkCOI}
              onCheck={(check) => setCheckCOI(check)}
              disabled={formSchema.disabled || isLoading}
            /> */}

            <COIValidateWidget
              disabled={formSchema.disabled || isLoading}
              isCOIPass={isCOIPass}
              setIsCOIPass={setIsCOIPass}
              checkCOI={checkCOI}
              setCheckCOI={setCheckCOI}
              setIsCheckCOI={setIsCheckCOI}
              setCheckInterest={setCheckInterest}
              checkInterest={checkInterest}
              fixType={'8'}
            />

            {formSchema.assetWarningMessage && <Message showIcon type="warning" description={formSchema.assetWarningMessage} />}

            {!!errorMessage && (
              <Col style={{ marginBottom: 10 }} xs={24} sm={24} md={24} lg={24}>
                <Message showIcon type="error" description={errorMessage} />
              </Col>
            )}
            <Col style={{ marginBottom: 20, textAlign: 'right' }} xs={24} sm={24} md={24} lg={24}>
              <Button
                style={{ width: 160 }}
                // appearance="ghost"
                color="rgb(45, 168, 136)"
                appearance="primary"
                onClick={handleSubmit(onSubmitOfferingApproveProposal)}
                // disabled={formSchema.disabled || isLoading || !checkCOI || !isCOIPass}
                disabled={
                  formSchema.disabled ||
                  isLoading ||
                  (!isCheckCOI && !checkInterest) ||
                  (!checkCOI && !checkInterest)
                }
              >
                {formSchema.buttonOfferingApproveProposalLabel}
              </Button>
            </Col>
            <Col style={{ marginBottom: 20, textAlign: 'right' }} xs={24} sm={24} md={24} lg={24}>
              <Button
                style={{ width: 160 }}
                appearance="ghost"
                onClick={handleSubmit(onSubmitSendToEdit)}
                icon={<Icon appearance="ghost" icon="edit" />}
                disabled={formSchema.disabled || isLoading}
              >
                {formSchema.buttonSendEditProposalLabel}
              </Button>
            </Col>
          </>
        </Panel>
        <ConfirmWidget
          title={`ยืนยัน${formSchema.buttonOfferingApproveProposalLabel}`}
          show={isShowConfimModalOffering}
          detail={`กรุณายืนยัน${formSchema.buttonOfferingApproveProposalLabel}`}
          onCancle={() => setIsShowConfimModalOffering(false)}
          onConfirm={handleSubmit(handleOnConfirmModalOffering)}
        />
        <ConfirmWidget
          title={`ยืนยัน${formSchema.buttonSendEditProposalLabel}`}
          show={isShowConfimModalEdit}
          detail={`กรุณายืนยัน${formSchema.buttonSendEditProposalLabel}`}
          onCancle={() => setIsShowConfimModalEdit(false)}
          onConfirm={handleSubmit(handleOnConfirmModalEdit)}
        />
      </Form>
    </>
  )
}
